export enum CountryCode {
    ENGLISH = 'en',
    SPANISH = 'es',
    FRENCH = 'fr',
    PORTUGUESE = 'pt',
}
